// extracted by mini-css-extract-plugin
export default {"textWrapEllipsis":"textWrapEllipsis--XvJlp","rowItem":"rowItem--lpFxJ"};